import React from 'react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Badge } from '../../components/ui/badge';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../components/ui/select';
import {
  Building2, User, MapPin, DollarSign, Activity,
  Shield, ArrowRight, Loader2, CircleDot,
} from 'lucide-react';
import { toast } from 'sonner';
import SiretInput from '../../components/ui/SiretInput';

export default function EtapeInformations({ formData, setFormData, handleInputChange, tarification, activites_selectionnees, handleCreerSouscription, loading, territoires, montants_personnalises }) {
  return (
    <div className="bg-slate-800/50 backdrop-blur-sm border border-slate-700/50 rounded-2xl overflow-hidden shadow-xl">
      <div className="bg-gradient-to-r from-slate-800 to-slate-700 px-8 py-6 border-b border-slate-600/50">
        <div className="flex items-center space-x-4">
          <div className="w-12 h-12 bg-amber-500/20 rounded-xl flex items-center justify-center">
            <Building2 className="h-6 w-6 text-amber-500" />
          </div>
          <div>
            <h2 className="text-xl font-bold text-white">Informations de l'entreprise</h2>
            <p className="text-slate-400 text-sm">Renseignez les informations pour finaliser votre souscription</p>
          </div>
        </div>
      </div>

      <div className="p-8 space-y-4 md:space-y-8">
        <div>
          <h3 className="text-sm font-semibold text-amber-400 uppercase tracking-wider mb-4 flex items-center">
            <CircleDot className="h-4 w-4 mr-2" />Identification de l'entreprise
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="md:col-span-2">
              <Label htmlFor="raison_sociale" className="text-slate-300">Raison sociale *</Label>
              <Input id="raison_sociale" name="raison_sociale" value={formData.raison_sociale} onChange={handleInputChange}
                placeholder="Ex: CONSTRUCTION MODERNE SARL" className="mt-2 bg-slate-900/50 border-slate-600 text-white placeholder:text-slate-500 focus:border-amber-500 focus:ring-amber-500/20" />
            </div>
            <div>
              <Label htmlFor="siret" className="text-slate-300">SIRET * (14 chiffres)</Label>
              <div className="mt-2">
                <SiretInput value={formData.siret} onChange={(val) => setFormData(prev => ({ ...prev, siret: val }))} showLabel={false}
                  className="[&_input]:bg-slate-900/50 [&_input]:border-slate-600 [&_input]:text-white"
                  onAutoComplete={(data) => {
                    setFormData(prev => ({ ...prev, raison_sociale: data.raison_sociale || prev.raison_sociale, code_naf: data.code_naf || prev.code_naf, adresse: data.adresse || prev.adresse, code_postal: data.code_postal || prev.code_postal, ville: data.ville || prev.ville }));
                    toast.success('Donnees entreprise recuperees');
                  }} />
              </div>
            </div>
            <div>
              <Label htmlFor="effectif" className="text-slate-300">Effectif de l'entreprise *</Label>
              <Input id="effectif" name="effectif" type="number" value={formData.effectif} onChange={handleInputChange}
                placeholder="Ex: 15" className="mt-2 bg-slate-900/50 border-slate-600 text-white placeholder:text-slate-500 focus:border-amber-500" />
            </div>
          </div>
        </div>

        <div>
          <h3 className="text-sm font-semibold text-amber-400 uppercase tracking-wider mb-4 flex items-center">
            <User className="h-4 w-4 mr-2" />Responsable legal
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <Label htmlFor="nom_gerant" className="text-slate-300">Nom du gerant *</Label>
              <Input id="nom_gerant" name="nom_gerant" value={formData.nom_gerant} onChange={handleInputChange} placeholder="Dupont"
                className="mt-2 bg-slate-900/50 border-slate-600 text-white placeholder:text-slate-500 focus:border-amber-500" />
            </div>
            <div>
              <Label htmlFor="prenom_gerant" className="text-slate-300">Prenom du gerant *</Label>
              <Input id="prenom_gerant" name="prenom_gerant" value={formData.prenom_gerant} onChange={handleInputChange} placeholder="Jean"
                className="mt-2 bg-slate-900/50 border-slate-600 text-white placeholder:text-slate-500 focus:border-amber-500" />
            </div>
          </div>
        </div>

        <div>
          <h3 className="text-sm font-semibold text-amber-400 uppercase tracking-wider mb-4 flex items-center">
            <MapPin className="h-4 w-4 mr-2" />Siege social
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="md:col-span-2">
              <Label htmlFor="adresse_entreprise" className="text-slate-300">Adresse *</Label>
              <Input id="adresse_entreprise" name="adresse_entreprise" value={formData.adresse_entreprise} onChange={handleInputChange}
                placeholder="123 Rue de la Construction" className="mt-2 bg-slate-900/50 border-slate-600 text-white placeholder:text-slate-500 focus:border-amber-500" />
            </div>
            <div>
              <Label htmlFor="code_postal" className="text-slate-300">Code postal *</Label>
              <Input id="code_postal" name="code_postal" value={formData.code_postal} onChange={handleInputChange} placeholder="97100"
                className="mt-2 bg-slate-900/50 border-slate-600 text-white placeholder:text-slate-500 focus:border-amber-500" />
            </div>
            <div>
              <Label htmlFor="ville" className="text-slate-300">Ville *</Label>
              <Input id="ville" name="ville" value={formData.ville} onChange={handleInputChange} placeholder="Basse-Terre"
                className="mt-2 bg-slate-900/50 border-slate-600 text-white placeholder:text-slate-500 focus:border-amber-500" />
            </div>
          </div>
        </div>

        <div>
          <h3 className="text-sm font-semibold text-amber-400 uppercase tracking-wider mb-4 flex items-center">
            <Shield className="h-4 w-4 mr-2" />Informations legales et territorialite
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div>
              <Label htmlFor="statut_juridique" className="text-slate-300">Statut Juridique *</Label>
              <Select value={formData.statut_juridique} onValueChange={(value) => setFormData(prev => ({...prev, statut_juridique: value}))}>
                <SelectTrigger className="mt-2 bg-slate-900/50 border-slate-600 text-white focus:border-amber-500"><SelectValue placeholder="Selectionner..." /></SelectTrigger>
                <SelectContent className="bg-slate-800 border-slate-600">
                  {['SARL', 'SAS', 'EURL', 'SA', 'SCI', 'EI', 'MICRO', 'ASSOCIATION', 'COOPERATIVE', 'AUTRE'].map(s => (
                    <SelectItem key={s} value={s} className="text-white hover:bg-slate-700">{s}</SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
            <div>
              <Label htmlFor="code_naf" className="text-slate-300">Code NAF *</Label>
              <Input id="code_naf" name="code_naf" placeholder="Ex: 4399C" value={formData.code_naf} onChange={handleInputChange}
                className="mt-2 bg-slate-900/50 border-slate-600 text-white placeholder:text-slate-500 focus:border-amber-500 font-mono" />
            </div>
            <div>
              <Label htmlFor="territoire" className="text-slate-300">Territoire d'exercice *</Label>
              <Select value={formData.territoire} onValueChange={(value) => setFormData(prev => ({...prev, territoire: value}))}>
                <SelectTrigger className="mt-2 bg-slate-900/50 border-slate-600 text-white focus:border-amber-500"><SelectValue placeholder="Selectionner..." /></SelectTrigger>
                <SelectContent className="bg-slate-800 border-slate-600">
                  {territoires.filter(t => t.nom && t.nom.trim() !== '').map((t) => (
                    <SelectItem key={t.id} value={t.nom} className="text-white hover:bg-slate-700">{t.nom}</SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
          </div>
        </div>

        {activites_selectionnees && Object.values(activites_selectionnees).some(arr => arr?.length > 0) && (
          <div>
            <h3 className="text-sm font-semibold text-amber-400 uppercase tracking-wider mb-4 flex items-center">
              <Activity className="h-4 w-4 mr-2" />Activites selectionnees
            </h3>
            <div className="flex flex-wrap gap-2">
              {activites_selectionnees?.gros_oeuvre?.length > 0 && <Badge className="bg-blue-500/20 text-blue-400 border border-blue-500/30">Gros Oeuvre: {activites_selectionnees.gros_oeuvre.length}</Badge>}
              {activites_selectionnees?.second_oeuvre?.length > 0 && <Badge className="bg-emerald-500/20 text-emerald-400 border border-emerald-500/30">Second Oeuvre: {activites_selectionnees.second_oeuvre.length}</Badge>}
              {activites_selectionnees?.travaux_publics?.length > 0 && <Badge className="bg-purple-500/20 text-purple-400 border border-purple-500/30">Travaux Publics: {activites_selectionnees.travaux_publics.length}</Badge>}
              {activites_selectionnees?.pib?.length > 0 && <Badge className="bg-orange-500/20 text-orange-400 border border-orange-500/30">PIB: {activites_selectionnees.pib.length}</Badge>}
            </div>
          </div>
        )}

        <div className="bg-gradient-to-br from-amber-500/10 to-amber-600/5 border border-amber-500/30 rounded-xl p-6">
          <h3 className="text-sm font-semibold text-amber-400 uppercase tracking-wider mb-4 flex items-center">
            <DollarSign className="h-4 w-4 mr-2" />Recapitulatif financier
          </h3>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <p className="text-slate-400 text-sm">Chiffre d'affaires</p>
              <p className="text-white font-semibold text-lg">{(formData.chiffre_affaires || 0).toLocaleString('fr-FR')} EUR</p>
            </div>
            <div>
              <p className="text-slate-400 text-sm">Montant de base</p>
              <p className="text-white font-semibold text-lg">{(montants_personnalises?.montant_ht_personnalise || tarification?.montant_ht || tarification?.montantHT || formData.montant_ht_contribution || 0).toLocaleString('fr-FR')} EUR</p>
            </div>
          </div>
          <div className="mt-4 pt-4 border-t border-amber-500/30">
            <div className="flex justify-between items-center">
              <span className="text-white font-semibold">Montant Global</span>
              <span className="text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-amber-400 to-amber-600">
                {(montants_personnalises?.montant_ttc_personnalise || tarification?.montant_ttc || tarification?.montantTTC || (formData.montant_ht_contribution * 1.1) || 0).toLocaleString('fr-FR')} EUR
              </span>
            </div>
          </div>
        </div>

        <Button onClick={handleCreerSouscription} disabled={loading}
          className="w-full h-14 bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 text-white font-semibold text-lg shadow-lg shadow-amber-500/20">
          {loading ? (<><Loader2 className="mr-2 h-5 w-5 animate-spin" />Creation en cours...</>) : (<>Valider et generer les documents<ArrowRight className="ml-2 h-5 w-5" /></>)}
        </Button>
      </div>
    </div>
  );
}
